module.exports = __webpack_public_path__ + "img/1-WHEEL.a23a9cb4.png";